import { SearchOption } from '@models/types/components/Search.type';

export function orderOptions(
  options: SearchOption[],
  order: 'JSON' | 'alphabetical' | undefined,
  jsonOrder?: string[]
): SearchOption[] {
  if (!order || order === 'alphabetical') {
    return [...options].sort((a, b) => a.label.localeCompare(b.label));
  }

  if (order === 'JSON' && jsonOrder) {
    return [...options].sort((a, b) => {
      const indexA = jsonOrder.indexOf(a.value);
      const indexB = jsonOrder.indexOf(b.value);
      const inA = indexA !== -1;
      const inB = indexB !== -1;

      if (inA && inB) return indexA - indexB;
      if (inA) return -1;
      if (inB) return 1;
      return 0;
    });
  }

  return [...options]; // fallback
}
